import { post } from '@/utils/request'

/**
 * 获取系统配置信息
 */
export function getConfig(data) {
  return post('config', data)
}